module.exports = __webpack_public_path__ + "static/media/menuClock.9d84d785.svg";